import { useEffect } from 'react';
import Footer from '../components/Footer';

export default function PrivacyPolicy() {
  useEffect(() => {
    document.title = 'Informativa sulla Privacy - CAI Modena Gite';
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="bg-white rounded-lg shadow-xl p-8 mb-8">
          <h1 className="text-3xl font-bold text-gray-800 mb-6 text-center">
            Informativa sulla Privacy
          </h1>

          <div className="prose prose-lg max-w-none text-gray-700">
            <p className="mb-6">
              Questa informativa spiega quali dati personali raccogliamo e come li utilizziamo.
            </p>

            {/* Quali dati raccogliamo */}
            <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">
              Quali dati raccogliamo
            </h2>

            <h3 className="text-lg font-medium text-gray-800 mt-6 mb-3">
              Dati di registrazione
            </h3>
            <ul className="list-disc pl-6 mb-4 space-y-1">
              <li><strong>Nome e cognome</strong></li>
              <li><strong>Email</strong></li>
              <li><strong>Password</strong> — conservata in forma crittografata, mai in chiaro</li>
              <li><strong>Iscrizione al CAI</strong> — per calcolare la quota di partecipazione</li>
              <li><strong>Telefono</strong></li>
              <li><strong>Data di nascita</strong> (opzionale)</li>
            </ul>

            <h3 className="text-lg font-medium text-gray-800 mt-6 mb-3">
              Dati di partecipazione
            </h3>
            <ul className="list-disc pl-6 mb-4 space-y-1">
              <li><strong>Iscrizioni alle gite</strong> e relativo stato (in attesa, approvata, non approvata)</li>
              <li><strong>Risposte ai moduli</strong> — se la gita richiede informazioni aggiuntive</li>
              <li><strong>Gite preferite</strong></li>
            </ul>

            <h3 className="text-lg font-medium text-gray-800 mt-6 mb-3">
              Dati tecnici
            </h3>
            <ul className="list-disc pl-6 mb-4 space-y-1">
              <li><strong>Indirizzo IP</strong> — registrato nei log di sicurezza</li>
              <li><strong>Token di sessione</strong> — memorizzato nel browser per mantenerti collegato</li>
            </ul>

            {/* Condivisione */}
            <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">
              Visibilità dei dati
            </h2>
            <p className="mb-4">
              Gli <strong>organizzatori delle gite</strong> possono vedere nome, cognome, telefono, email
              e risposte ai moduli dei partecipanti alle loro gite.
            </p>

            {/* Cookie e tracking */}
            <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">
              Cookie e tracciamento
            </h2>
            <p className="mb-4">
              Non utilizziamo cookie di profilazione né servizi di analytics di terze parti.
              Memorizziamo solo il token di autenticazione nel browser.
            </p>

            {/* Diritti */}
            <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">
              I tuoi diritti
            </h2>
            <p className="mb-4">
              Dalla pagina "Il mio account" puoi:
            </p>
            <ul className="list-disc pl-6 mb-4 space-y-1">
              <li><strong>Scaricare i tuoi dati</strong> in formato JSON</li>
              <li><strong>Eliminare il tuo account</strong> e tutti i dati associati</li>
              <li><strong>Modificare</strong> i tuoi dati personali</li>
            </ul>

            <p className="text-gray-500 text-sm mt-8">
              Ultimo aggiornamento: Febbraio 2026
            </p>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
}